import React from 'react';
import { ListingCard } from 'shared-components/ViewFragments/SearchPage/ListingCard';
import { DataImages } from 'shared-components/Components/Property/PropertyCard/CardImageGallery/web';
import { UltimosIngresosItem } from './graphql';
import './style.css';

interface UltimosIngresosPropertyCardProps {
	data: UltimosIngresosItem;
	preloadImg?: boolean;
}

export const UltimosIngresosPropertyCard: React.FC<UltimosIngresosPropertyCardProps> = ({ data, preloadImg = false }) => {
	
	const images: DataImages[] = data.image ? [{
		id: 1,
		image: data.image.replace(/th.(outside)?\d+x\d+./, ''), //le saco el resize para que lo haga la galería
		tag: null
	}] : [];

	const propertyData = {
		id: data.id,
		legacy_propID: data.id,
		title: data.title,
		link: data.link,
		img: data.image,
		width: 300,
		height: 225,
		description: data.content,
		subtitle: data.content,
		
		price: {
			amount: Math.max(parseInt(data.price) || 5, 5),
			currency: { name: '$' } as any
		},
		currency: { name: '$' } as any,
		hidePrice: false,
		
		operation_type: data.content.includes('alquiler') ? 'rent' : 'sale',
		operation_type_id: data.content.includes('alquiler') ? 2 : 1,
		
		images: images,
		image_count: images.length,
		
		address: data.location,
		neighborhood: {
			name: data.location.split(',')[0] || data.location
		},
		// Para que se muestre la ubicación específica
		locations: [{
			name: data.location,
			country: 'Colombia',
			// Estructura compatible con getLocationLabel
			neighbourhood: [{ name: data.location.split(',')[0] || data.location }],
			city: data.location.includes(',') ? [{ name: data.location.split(',')[1]?.trim() || 'Bogotá' }] : [{ name: 'Bogotá' }],
			state: [{ name: 'Cundinamarca' }]
		}],
		
		property_type: {
			name: data.category
		},
		property_type_id: data.category,

		// Datos de GraphQL
		bedrooms: data.bedrooms || 0,
		bathrooms: data.bathrooms || 0,
		m2: data.area,

		singleImage: true,
		isExternal: false,
	}; 

	return (
		<ListingCard 
			shortCard={true} 
			data={propertyData} 
			preloadImg={preloadImg} 
			hideCta 
			staticGallery 
			showExpenses={false}
		/>
	);
};
